// wishlistURL, wishlistItemDeleteURL, wishlistItemURL, wishlistMergeURL, and wishlistCurrency
// are set per-store in the ma-wishlist-js.liquid snippet

function setStoredObject(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

function getStoredObject(key) {
  var value = localStorage.getItem(key);
  return value && JSON.parse(value);
}

/**
 * Get wishlist from API
 * @param {*} identifier 
 * @param {*} type 
 * @returns 
 */
async function getWishListAPI(identifier, type = 'id') {
  try {
    var queryData = { wishlist_id: identifier };
    if (type !== "id") {
      queryData = { email: identifier };
    }
    const result = await $.ajax({
      type: "GET",
      url: wishlistURL,
      dataType: 'json',
      data: queryData
    });

    return result;

  } catch (error) {
    return {};
  }
}

/**
 * Save wishlist
 * @param {*} identifier 
 * @param {*} type 
 * @returns 
 */
async function saveWishListAPI(data) {
  try {
    const saveWishlistData = {
      wishlist_id: data?.wishlist_id,
      items: data?.items,
      customer_email: data?.customer_email,
    };
    const result = await $.ajax({
      type: "POST",
      url: wishlistURL,
      dataType: 'json',
      data: saveWishlistData
    });

    return result;

  } catch (error) {
    return {};
  }
}

/**
 * @param {*} productData
 * @returns 
 */
async function addWishlistItemAPI(wishlistId, productId, variantId, sku) {
  try {
    const addItemData = {
      wishlist_id: wishlistId,
      product_id: productId,
      variant_id: variantId,
      sku
    };
    const result = await $.ajax({
      type: "POST",
      url: wishlistItemURL,
      dataType: 'json',
      data: addItemData
    });
    return result;
  } catch (error) {
    return {};
  }
}

/**
 * delete api
 * @param {*} productData 
 * @returns 
 */
async function deleteWishListItemAPI(wishlistId, item_ids) {
  try {
    const postData = {
      wishlist_id: wishlistId,
      items: item_ids
    };
    const result = await $.ajax({
      type: "POST",
      url: wishlistItemDeleteURL,
      dataType: 'json',
      data: postData
    });
    return result;
  } catch (error) {
    return false;
  }
}

/**

 * @param {*} productDataDelete 
 * @returns 
 */
async function deleteWishlistItem(customerEmail, variantId) {
  try {
    const wishlist = await getWishlist(customerEmail);
    if (wishlist?.items?.length) {
      const deleteWishlistItemList = [];
      const result = wishlist?.items?.find((elm) => elm.variant_id === variantId);
      if (result) {
        deleteWishlistItemList.push(result?.item_id)
        const response = await deleteWishListItemAPI(wishlist?.wishlist_id, deleteWishlistItemList);
        if (response?.wishlist_id) {
          const updatedTime = new Date();
          const updatedTimeMillisec = updatedTime.getTime();
          const wishlistData = {
            wishlist: response,
            customer_email: response?.customer_email || '',
            updatedAt: updatedTimeMillisec
          }
          setStoredObject('ma_wishlist', wishlistData);
        }
        return response;
      } else {
        return {};
      }
    }
  } catch (error) {
    return {};
  }
}

/**

 * @param {*} productDataDelete 
 * @returns 
 */
async function deleteWishlistItemByProductId(customerEmail, productId) {
  try {
    const wishlist = await getWishlist(customerEmail);
    if (wishlist?.items?.length) {
      const deleteWishlistItemList = [];
      wishlist?.items.map(wi => {
        if (wi?.product_id === '' + productId) {
          deleteWishlistItemList.push(wi?.item_id)
        }
      });

      const response = await deleteWishListItemAPI(wishlist?.wishlist_id, deleteWishlistItemList);
      if (response?.wishlist_id) {
        const updatedTime = new Date();
        const updatedTimeMillisec = updatedTime.getTime();
        const wishlistData = {
          wishlist: response,
          customer_email: response?.customer_email || '',
          updatedAt: updatedTimeMillisec
        }
        setStoredObject('ma_wishlist', wishlistData);
      }
      return response;
    }
  } catch (error) {
    return {};
  }
}

async function deleteWishlistItemByItemId(customerEmail, itemId) {
  try {
    const wishlist = await getWishlist(customerEmail);
    if (wishlist?.items?.length) {
      const response = await deleteWishListItemAPI(wishlist?.wishlist_id, [itemId]);
      if (response?.wishlist_id) {
        const updatedTime = new Date();
        const updatedTimeMillisec = updatedTime.getTime();
        const wishlistData = {
          wishlist: response,
          customer_email: response?.customer_email || '',
          updatedAt: updatedTimeMillisec
        }
        setStoredObject('ma_wishlist', wishlistData);
      }
      return response;
    }
  } catch (error) {
    return {};
  }
}

/** Delete Item by SKu
 * 
 * @param {*} customerEmail 
 * @param {*} sku 
 * @returns 
 */
async function deleteWishlistItemBySku(customerEmail, sku) {
  try {
    const wishlist = await getWishlist(customerEmail);
    if (wishlist?.items?.length) {
      const deleteWishlistItemList = [];
      const result = wishlist?.items?.find((elm) => elm?.sku === sku);
      if (result) {
        deleteWishlistItemList.push(result?.item_id)
        const response = await deleteWishListItemAPI(wishlist?.wishlist_id, deleteWishlistItemList);
        if (response?.wishlist_id) {
          const updatedTime = new Date();
          const updatedTimeMillisec = updatedTime.getTime();
          const wishlistData = {
            wishlist: response,
            customer_email: response?.customer_email || '',
            updatedAt: updatedTimeMillisec
          }
          setStoredObject('ma_wishlist', wishlistData);
        }
        return response;
      } else {
        return {};
      }
    }
  } catch (error) {
    console.log(error);
    return {};
  }
}

/**
 * 
 * @param {*} productData 
 */
async function addProductToWishList(customerEmail, data) {
  const wishlist = await getWishlist(customerEmail);
  const response = await addWishlistItemAPI(wishlist?.wishlist_id, data?.product_id, data?.variant_id)
  if (response?.wishlist_id) {
    const updatedTime = new Date();
    const updatedTimeMillisec = updatedTime.getTime();
    const wishlistData = {
      wishlist: response,
      customer_email: customerEmail,
      updatedAt: updatedTimeMillisec
    }
    setStoredObject('ma_wishlist', wishlistData);
  }
  return response;
}

/**
 * Add Product to wishlist by SKU
 * @param {*} customerEmail 
 * @param {*} sku 
 * @returns 
 */
async function addProductToWishListBySku(customerEmail, sku) {
  const wishlist = await getWishlist(customerEmail);
  const response = await addWishlistItemAPI(wishlist?.wishlist_id, undefined, undefined, sku)
  if (response?.wishlist_id) {
    const updatedTime = new Date();
    const updatedTimeMillisec = updatedTime.getTime();
    const wishlistData = {
      wishlist: response,
      customer_email: customerEmail,
      updatedAt: updatedTimeMillisec
    }
    setStoredObject('ma_wishlist', wishlistData);
  }
  return response;
}

async function getWishlist(customerEmail = '') {
  if (customerEmail !== '') {
    const localWishlist = getStoredObject('ma_wishlist');
    if (!localWishlist) {
      const currentTime = new Date();
      const currentTimeInMili = currentTime.getTime();
      let result = await getWishListAPI(customerEmail, 'email');
      if (!result?.wishlist_id) {
        result = await saveWishListAPI({ customer_email: customerEmail });
      }
      const wishlistData = {
        wishlist: result?.wishlist_id ? result : {},
        customer_email: customerEmail,
        updatedAt: currentTimeInMili
      }
      setStoredObject('ma_wishlist', wishlistData);
      return result;
    } else {
      if (localWishlist?.customer_email) {
        const currentTime = new Date();
        const currentTimeInMili = currentTime.getTime();
        var resultInMinutes = Math.round((currentTimeInMili - localWishlist?.updatedAt) / 60000);

        if (resultInMinutes < 2) {
          return localWishlist?.wishlist;
        } else {
          const result = await getWishListAPI(localWishlist?.wishlist?.wishlist_id);
          if (result?.wishlist_id) {
            const wishlistData = {
              wishlist: result,
              customer_email: customerEmail,
              updatedAt: currentTimeInMili
            }
            setStoredObject('ma_wishlist', wishlistData);
            return result;
          } else {
            let newWishlist = await saveWishListAPI(localWishlist?.wishlist);
            const wishlistData = {
              wishlist: newWishlist?.wishlist_id ? newWishlist : {},
              customer_email: customerEmail,
              updatedAt: currentTimeInMili
            }
            setStoredObject('ma_wishlist', wishlistData);
            return newWishlist;
          }
        }
      } else {
        const result = await getWishListAPI(localWishlist?.wishlist?.wishlist_id);
        let updatedResult;
        if (result?.wishlist_id) {
          updatedResult = await mergeWishlist(localWishlist?.wishlist?.wishlist_id, customerEmail);
          return updatedResult;
        } else {
          const currentTime = new Date();
          const currentTimeInMili = currentTime.getTime();
          const wishlistSaveData = localWishlist?.wishlist;
          wishlistSaveData['customer_email'] = customerEmail;
          const newWishlist = await saveWishListAPI(wishlistSaveData);
          const wishlistData = {
            wishlist: newWishlist?.wishlist_id ? newWishlist : {},
            customer_email: customerEmail,
            updatedAt: currentTimeInMili
          }
          setStoredObject('ma_wishlist', wishlistData);
          return newWishlist;
        }
      }
    }
  } else {
    const localWishlist = getStoredObject('ma_wishlist');
    if (!localWishlist) {
      return {}
    } else {
      return localWishlist?.wishlist;
    }
  }
}

async function mergeWishlist(wishlist_id, customerEmail) {
  try {
    const postData = {
      "wishlist_id": wishlist_id,
      "email": customerEmail
    };
    const result = await $.ajax({
      type: "POST",
      url: wishlistMergeURL,
      dataType: 'json',
      data: postData
    });

    if (result?.wishlist_id) {
      const updatedTime = new Date();
      const updatedTimeMillisec = updatedTime.getTime();
      const wishlistData = {
        wishlist: result,
        customer_email: customerEmail,
        updatedAt: updatedTimeMillisec
      }
      setStoredObject('ma_wishlist', wishlistData);
      return result;
    } else {
      console.log(`Error merging the wishlist`);
      return {};
    }
  } catch (error) {
    return {};
  }
}

/**
 * Push wishlist-add events to the GTM dataLayer.
 *
 * Every surface fires a generic `add_to_wishlist` tagged with `wishlist_source`,
 * so GTM's generic tag captures adds from anywhere (collection grid, cart,
 * home, search, recommendation tiles, PDP, Roomvo). The two surfaces GTM tags
 * individually — 'pdp' and 'roomvo' — ALSO get a source-specific
 * `add_to_wishlist_from_<source>` event for granularity.
 *
 * `identifier` is the item id: a SKU where available (PDP/Roomvo), otherwise
 * the product id (grid/recommendation cards expose only product_id). `extra`
 * lets callers enrich items[0] (price, variant, etc.).
 *
 * @param {string|number} identifier  SKU or product id → items[0].item_id
 * @param {'collection'|'cart'|'home'|'search'|'page'|'recommendation'|'pdp'|'roomvo'|string} [source='unknown']
 * @param {object} [extra]  Optional fields merged into items[0]
 */
async function sendToGTM(identifier, source, extra) {
  if (typeof window === 'undefined' || !identifier) return;
  window.dataLayer = window.dataLayer || [];
  var src = (typeof source === 'string' && source) ? source : 'unknown';
  var ecommerce = {
    currency: (typeof wishlistCurrency !== 'undefined' && wishlistCurrency) ? wishlistCurrency : 'AUD',
    items: [Object.assign({ item_id: identifier }, extra || {})]
  };

  // Generic event — fires on every surface, distinguished by wishlist_source.
  window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce object.
  window.dataLayer.push({
    event: 'add_to_wishlist',
    wishlist_source: src,
    ecommerce: ecommerce
  });

  // Source-specific events kept for the surfaces GTM already tags individually.
  if (src === 'pdp' || src === 'roomvo') {
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_wishlist_from_' + src,
      ecommerce: ecommerce
    });
  }
}

// to call when logout
async function clearStorage() {
  setStoredObject('ma_wishlist', null);
}